import routesBookDemo from './routes-book-demo';
import routesEmp from './routes-emp';
import routesEnterprise from './routes-enterprise';
import routesExec from './routes-exec';
import routesGopro from './routes-gopro';
import routesMap from './routes-map';
import routesMarketplace from './routes-marketplace';
import routesNewsfeed from './routes-newsfeed';
import routesPricing from './routes-pricing';
import routesProfile from './routes-profile';
import routesRefer from './routes-refer';
import routesReport from './routes-report';
import routesRoster from './routes-roster';
import routesTasks from './routes-tasks';
import routesTimesheet from './routes-timesheet';
import routesVideo from './routes-video';
import {
  clearAIContentScope,
  dockAppInMenu,
  findMyMenu,
  setAIAffectsContent,
  showSideTeamStatusBar,
  tabHighlight,
  unDockAppInMenu,
} from './helpers';
import { getCurrentRoute, getPreviousRoute, getRouter } from '../helpers';
import documentReady from '@webapp-next/lib/document-ready';
import { getRootDeputyFrame } from '@webapp-next/global-libs/deputy-embed';

const routes = [
  ...routesBookDemo,
  ...routesEmp,
  ...routesEnterprise,
  ...routesExec,
  ...routesGopro,
  ...routesMap,
  ...routesMarketplace,
  ...routesNewsfeed,
  ...routesPricing,
  ...routesProfile,
  ...routesRefer,
  ...routesReport,
  ...routesRoster,
  ...routesTasks,
  ...routesTimesheet,
  ...routesVideo,
];

export default routes;

export function beforeEach() {
  // Mirrors the Backbone router's execute() override: drop the AI content scope
  // up front so only the roster handlers put it back. Ahead of the early return
  // below, otherwise a re-entered route keeps the previous route's scope.
  clearAIContentScope();

  if (DP.map) {
    DP.map.nonFullScreen();
  }

  $dt.vwHelpLink.resetApps();

  const hash = getRootDeputyFrame()?.location?.hash || '#home';

  const { hash: lastHash } =
    window.$dt.rtrMain.history[window.$dt.rtrMain.history.length - 1] || {};

  if (lastHash === hash) {
    return;
  }

  // garbage collector (keep last 10 routes)
  window.$dt.rtrMain.history = window.$dt.rtrMain.history.slice(
    window.$dt.rtrMain.history.length - 10
  );

  window.$dt.rtrMain.history.push(getCurrentRoute());
}

export function takeOverNavBar() {
  const router = getRouter();
  const tabs = [
    ...window.document.querySelectorAll('#main-nav li'),
    ...window.document.querySelectorAll('#main-nav .dropdown-menu li'),
  ];

  tabs.forEach(tab =>
    tab.addEventListener('click', (evt = {}) => {
      evt.preventDefault();
      let target = evt.target;

      // make sure the menu clicked is the correct link
      if (target.tagName !== 'A') {
        const parentNode = target.parentNode;

        if (parentNode.tagName === 'A') {
          target = parentNode;
        } else {
          const a = target.querySelector('a');
          if (a && a.tagName === 'A') {
            target = a;
          }
        }
      }

      const [host, path] = (target?.href || '').split('#') || []; // eslint-disable-line no-unused-vars
      const isDropDown = target.getAttribute('data-toggle') === 'dropdown';

      if (!isDropDown) {
        evt.stopPropagation();
      }

      if (path && path !== 'timesheet' && !isDropDown) {
        router.push(`/${path}`);
      }
    })
  );
}

function fixRoute(route = '') {
  return route.replace(/^\w/, r => `#${r}`);
}

export function classicRouterRetrofeed() {
  documentReady(takeOverNavBar);

  const internalFunctionTranslation = {
    showAllNewsfeed: 'newsfeed-module',
  };

  const classicToVueEventTranslation = {
    route(name, params) {
      console.log('classicToVue route', name, params);
      getRouter().push({
        name: internalFunctionTranslation[name],
        params,
      });
    },
  };

  window.$dt = getRootDeputyFrame()?.$dt || {};

  window.$dt.rtrMain = {
    on(...vars) {
      console.log('$dt.rtrMain.on', ...vars);
    },
    off(...vars) {
      console.log('$dt.rtrMain.off', ...vars);
    },
    showSideTeamStatusBar,
    tabHighlight,
    setAIAffectsContent,
    clearAIContentScope,
    trigger(type, name, args) {
      classicToVueEventTranslation[type](name, args);
    },
    dockAppInMenu,
    unDockAppInMenu,
    findMyMenu,
    history: [],
    navigate: (route = '') => getRouter().push(fixRoute(route)),
    pushDontTrigger: (route = '') => getRouter().replace(fixRoute(route)),
    replace: (route = '') => getRouter().replace(fixRoute(route)),
    $route: getCurrentRoute,
    $previousRoute: getPreviousRoute,
    isHashActive: () => (getPreviousRoute().hash || '').replace('#/', '#'),
  };

  window.$dt.rtrMain.history = [];
}
